{
  "deselectedItem": "{item} neselectat.",
  "select": "Selectare",
  "selectedAll": "Toate elementele selectate.",
  "selectedCount": "{count, plural, =0 {Niciun element selectat} one {# element selectat} other {# elemente selectate}}.",
  "selectedItem": "{item} selectat."
}
